import { Modal } from "@app/components";
import { Button } from "@app/controls";
import type { RootState } from "@app/redux";
import { Transition } from "@headlessui/react";
import React from "react";
import { useSelector } from "react-redux";
import "./activate-account-modal.css";
import messages from "./messages";
import type { ViewProperties } from "./properties";

const ActivateAccountModalView = React.memo((props: ViewProperties) => {
	const { language } = useSelector(
		(rootState: RootState) => rootState.language,
	);

	const colStyle = ["flex", "flex-col"].join(" ");

	const errorOuterStyle = [colStyle, "gap-y-2"].join(" ");

	const errorInnerStyle = [
		"font-primary-regular",
		"activate-account-modal-error",
	].join(" ");

	return (
		<Modal open={props.open} onClose={props.onClose}>
			<h1 className="activate-account-modal-heading font-primary-bold mb-8 text-2xl">
				{messages[language].header}
			</h1>
			<div className="flex flex-col gap-y-2 text-lg activate-account-modal-text">
				<span className="font-primary-regular">
					{messages[language].instruction.line1}
				</span>
				<span className="font-primary-regular mt-4">
					{messages[language].instruction.line2}
				</span>
				<span className="font-primary-regular">
					{messages[language].instruction.line3}
				</span>
				<span className="font-primary-regular mt-4">
					{messages[language].instruction.line4}
				</span>
			</div>
			<div className={props.formattedThrottling ? "mt-4" : "mt-6"}>
				<Transition
					show={props.formattedThrottling !== undefined}
					enter="transition ease-out duration-300"
					leave="transition east-out duration-300"
					enterFrom="opacity-0 translate-y-5"
					enterTo="opacity-100 translate-y-0"
					leaveTo="opacity-0 -translate-y-5"
				>
					<div className={errorOuterStyle}>
						<div className={errorInnerStyle}>
							{messages[language].error.pleaseWait}
						</div>
					</div>
				</Transition>
				<Button
					className="w-full font-primary-medium py-3 px-5"
					disabled={props.formattedThrottling !== undefined}
					theme="primary"
					onClick={props.onResend}
				>
					{props.formattedThrottling ?? messages[language].resendButton}
				</Button>
			</div>
		</Modal>
	);
});

export { ActivateAccountModalView };
